var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfiniteRefresh = function SvgInfiniteRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.808 2.212A7.507 7.507 0 0 1 15 7.538a7.501 7.501 0 0 1-1.511 4.527l1.422 1.432h-3.728V9.744l1.241 1.25a6.015 6.015 0 0 0 1.085-3.456 6.014 6.014 0 0 0-1.755-4.265 5.93 5.93 0 0 0-6.137-1.456L5.147.392a7.41 7.41 0 0 1 7.661 1.82zm-9.08 3.029L2.564 4.069a6.018 6.018 0 0 0-1.039 3.393c0 1.61.624 3.125 1.755 4.266a5.935 5.935 0 0 0 6.137 1.455l.472 1.424a7.424 7.424 0 0 1-7.663-1.818A7.512 7.512 0 0 1 .034 7.462c0-1.63.518-3.177 1.466-4.464L0 1.488h3.728v3.753z"
  })));
};

export default SvgInfiniteRefresh;